import { useExperience } from "../../../../../shared/context/ExperienceContext";

import { clinicContentByMode, clinicGallery } from "./data/clinicData";

import ClinicContent from "./components/ClinicContent/ClinicContent";
import ClinicGallery from "./components/ClinicGallery/ClinicGallery";
import ClinicNote from "./components/ClinicNote/ClinicNote";

import "./ClinicSection.css";

export default function ClinicSection() {
  const { mode } = useExperience();
  const content = clinicContentByMode[mode] || clinicContentByMode.all;

  return (
    <section className="clinic-section">
      <div className="container clinic-section__container">
        <div className="clinic-section__grid">
          <ClinicContent content={content} />

          <ClinicGallery gallery={clinicGallery} />
        </div>

        <ClinicNote content={content} />
      </div>
    </section>
  );
}